import { createReducer, on } from '@ngrx/store';
import { Contacto } from '../../../app/private/shared/models/Contacto';
import { Preguntas } from '../../../app/private/shared/models/preguntas';
import { IHome } from '../../../app/shared/models/Constants';
import { ContenidoClientes } from '../../../app/shared/models/ContenidoClientes';
import { ILegacyDocument } from '../../../app/shared/models/Legales';
import { IConfiguracion, IDataConfig } from '../../../app/shared/models/ParaTi.model';
import {
    clearContactProgram,
    clearGetContactInfo,
    clearGetMechanicsProgram,
    clearGetPrivacyNotice,
    clearGetQuestions,
    clearGetTermsAndConditions,
    contactProgram,
    contentCustomersV1,
    errorContactProgram,
    errorContentCustomersV1,
    errorGetClientProgram,
    errorGetContactInfo,
    errorGetInicioApp,
    errorGetMechanicsProgram,
    errorGetMuralData,
    errorGetPrivacyNotice,
    errorGetProfileConfig,
    errorGetQuestions,
    errorGetTermsAndConditions,
    errorRateOurAnswer,
    getClientProgram,
    getContactInfo,
    getInicioApp,
    getMechanicsProgram,
    getMuralData,
    getPrivacyNotice,
    getProfileConfig,
    getQuestions,
    getTermsAndConditions,
    // New actions
    rateOurAnswer,
    successContactProgram,
    successContentCustomersV1,
    successGetClientProgram,
    successGetContactInfo,
    successGetInicioApp,
    successGetMechanicsProgram,
    successGetMuralData,
    successGetPrivacyNotice,
    successGetProfileConfig,
    successGetQuestions,
    successGetTermsAndConditions,
    successRateOurAnswer
} from '../actions/content-management.actions';

/**
 * Definir la estructura del estado para ContactoPrograma
 */
export interface ContactProgramState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: Contacto[] | null;
}

/**
 * Estado inicial
 */
export const ContactProgramInit: ContactProgramState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: null
};

/**
 * Reducer
 */
const _contactProgramReducer = createReducer(
    ContactProgramInit,

    // Cuando contactProgram → Loading
    on(contactProgram, (state) => ({
        ...state,
        loading: true,
        success: false,
        failed: false,
        error: null,
    })),

    // Cuando successContactProgram → Guarda datos
    on(successContactProgram, (state, { data }) => ({
        ...state,
        loading: false,
        success: true,
        failed: false,
        error: null,
        data
    })),

    // Cuando errorContactProgram → Error
    on(errorContactProgram, (state, { payload }) => ({
        ...state,
        loading: false,
        success: false,
        failed: true,
        error: payload,
        data: null
    })),

    on(clearContactProgram, state => ({ ...state, ...ContactProgramInit }))
);

/**
 * Exporta la función del reducer
 */
export function ContactProgramReducer(state: any, action: any) {
    return _contactProgramReducer(state, action);
}



/**
 * ContenidoClientesV1
 */
export interface ContentCustomerState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: ContenidoClientes[] | null;
}

/**
 * Estado inicial
 */
export const ContentCustomerInit: ContentCustomerState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: null
};

/**
 * Reducer
 */
const _contentCustomerReducer = createReducer(
    ContentCustomerInit,

    on(contentCustomersV1, (state) => ({
        ...state,
        loading: true,
        success: false,
        failed: false,
        error: null,
    })),

    // Cuando successContentCustomersV1 → Guarda datos
    on(successContentCustomersV1, (state, { data }) => ({
        ...state,
        loading: false,
        success: true,
        failed: false,
        error: null,
        data
    })),

    // Cuando errorContentCustomersV1 → Error
    on(errorContentCustomersV1, (state, { payload }) => ({
        ...state,
        loading: false,
        success: false,
        failed: true,
        error: payload,
        data: null
    }))
);

/**
 * Exporta la función del reducer
 */
export function ContentCustomerReducer(state: any, action: any) {
    return _contentCustomerReducer(state, action);
}

/**
 * * Rate Our Answer State
 */
export interface RateOurAnswerState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: any | null;
}

export const RateOurAnswerInit: RateOurAnswerState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: null
};

const _rateOurAnswerReducer = createReducer(
    RateOurAnswerInit,
    on(rateOurAnswer, (state) => ({ ...state, loading: true, success: false, failed: false, error: null })),
    on(successRateOurAnswer, (state, { data }) => ({ ...state, loading: false, success: true, failed: false, error: null, data })),
    on(errorRateOurAnswer, (state, { payload }) => ({ ...state, loading: false, success: false, failed: true, error: payload, data: null }))
);

export function RateOurAnswerReducer(state: any, action: any) {
    return _rateOurAnswerReducer(state, action);
}

/**
 * * Mural Data State
 */
export interface MuralDataState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IDataConfig;
}

export const MuralDataInit: MuralDataState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {
        contenido: {
            todo: [],
            noticias: [],
            promos: []
        },
        configuracion: {} as IConfiguracion
    }
};

const _muralDataReducer = createReducer(
    MuralDataInit,
    on(getMuralData, (state) => ({ ...state, loading: true, success: false, failed: false, error: null })),
    on(successGetMuralData, (state, { data }) => ({ ...state, loading: false, success: true, failed: false, error: null, data })),
    on(errorGetMuralData, (state, { payload }) => ({ ...state, loading: false, success: false, failed: true, error: payload }))
);

export function MuralDataReducer(state: any, action: any) {
    return _muralDataReducer(state, action);
}

/**
 * * Privacy Notice State
 */
export interface PrivacyNoticeState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: ILegacyDocument;
}

export const PrivacyNoticeInit: PrivacyNoticeState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as ILegacyDocument
};

const _privacyNoticeReducer = createReducer(
    PrivacyNoticeInit,
    on(getPrivacyNotice, (state) => ({ ...state, loading: true, success: false, failed: false, error: null })),
    on(successGetPrivacyNotice, (state, { data }) => ({ ...state, loading: false, success: true, failed: false, error: null, data })),
    on(errorGetPrivacyNotice, (state, { payload }) => ({ ...state, loading: false, success: false, failed: true, error: payload })),
    on(clearGetPrivacyNotice, state => ({ ...state, ...PrivacyNoticeInit }))
);

export function PrivacyNoticeReducer(state: any, action: any) {
    return _privacyNoticeReducer(state, action);
}

/**
 * * Profile Config State
 */
export interface ProfileConfigState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: any | null;
}

export const ProfileConfigInit: ProfileConfigState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: null
};

const _profileConfigReducer = createReducer(
    ProfileConfigInit,
    on(getProfileConfig, (state) => ({ ...state, loading: true, success: false, failed: false, error: null })),
    on(successGetProfileConfig, (state, { data }) => ({ ...state, loading: false, success: true, failed: false, error: null, data })),
    on(errorGetProfileConfig, (state, { payload }) => ({ ...state, loading: false, success: false, failed: true, error: payload, data: null }))
);

export function ProfileConfigReducer(state: any, action: any) {
    return _profileConfigReducer(state, action);
}

/**
 * * Contact Info State
 */
export interface ContactInfoState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: any[];
}

export const ContactInfoInit: ContactInfoState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: []
};

const _contactInfoReducer = createReducer(
    ContactInfoInit,
    on(getContactInfo, (state) => ({ ...state, loading: true, success: false, failed: false, error: null })),
    on(successGetContactInfo, (state, { data }) => ({ ...state, loading: false, success: true, failed: false, error: null, data })),
    on(errorGetContactInfo, (state, { payload }) => ({ ...state, loading: false, success: false, failed: true, error: payload, data: [] })),
    on(clearGetContactInfo, state => ({ ...state, ...ContactInfoInit }))
);

export function ContactInfoReducer(state: any, action: any) {
    return _contactInfoReducer(state, action);
}

/**
 * * Inicio App State
 */
export interface InicioAppState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IHome;
}

export const InicioAppInit: InicioAppState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as IHome
};

const _inicioAppReducer = createReducer(
    InicioAppInit,
    on(getInicioApp, (state) => ({ ...state, loading: true, success: false, failed: false, error: null })),
    on(successGetInicioApp, (state, { data }) => ({ ...state, loading: false, success: true, failed: false, error: null, data })),
    on(errorGetInicioApp, (state, { payload }) => ({ ...state, loading: false, success: false, failed: true, error: payload }))
);

export function InicioAppReducer(state: any, action: any) {
    return _inicioAppReducer(state, action);
}

/**
 * * Mechanics Program State
 */
export interface MechanicsProgramState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: {imagen_url: string}[] | null;
}

export const MechanicsProgramInit: MechanicsProgramState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: null
};

const _mechanicsProgramReducer = createReducer(
    MechanicsProgramInit,
    on(getMechanicsProgram, (state) => ({ ...state, loading: true, success: false, failed: false, error: null })),
    on(successGetMechanicsProgram, (state, { data }) => ({ ...state, loading: false, success: true, failed: false, error: null, data })),
    on(errorGetMechanicsProgram, (state, { payload }) => ({ ...state, loading: false, success: false, failed: true, error: payload, data: null })),
    on(clearGetMechanicsProgram, state => ({ ...state, ...MechanicsProgramInit }))
);

export function MechanicsProgramReducer(state: any, action: any) {
    return _mechanicsProgramReducer(state, action);
}

/**
 * * Client Program State
 */
export interface ClientProgramState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: any | null;
}

export const ClientProgramInit: ClientProgramState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: null
};

const _clientProgramReducer = createReducer(
    ClientProgramInit,
    on(getClientProgram, (state) => ({ ...state, loading: true, success: false, failed: false, error: null })),
    on(successGetClientProgram, (state, { data }) => ({ ...state, loading: false, success: true, failed: false, error: null, data })),
    on(errorGetClientProgram, (state, { payload }) => ({ ...state, loading: false, success: false, failed: true, error: payload, data: null }))
);

export function ClientProgramReducer(state: any, action: any) {
    return _clientProgramReducer(state, action);
}

/**
 * * Terms and Conditions State
 */
export interface TermsAndConditionsState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: ILegacyDocument;
}

export const TermsAndConditionsInit: TermsAndConditionsState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as ILegacyDocument
};

const _termsAndConditionsReducer = createReducer(
    TermsAndConditionsInit,
    on(getTermsAndConditions, (state) => ({ ...state, loading: true, success: false, failed: false, error: null })),
    on(successGetTermsAndConditions, (state, { data }) => ({ ...state, loading: false, success: true, failed: false, error: null, data })),
    on(errorGetTermsAndConditions, (state, { payload }) => ({ ...state, loading: false, success: false, failed: true, error: payload })),
    on(clearGetTermsAndConditions, state => ({ ...state, ...TermsAndConditionsInit }))
);

export function TermsAndConditionsReducer(state: any, action: any) {
    return _termsAndConditionsReducer(state, action);
}

/**
 * * Questions State
 */
export interface QuestionsState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: Preguntas[];
}

export const QuestionsInit: QuestionsState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: []
};

const _questionsReducer = createReducer(
    QuestionsInit,
    on(getQuestions, (state) => ({ ...state, loading: true, success: false, failed: false, error: null })),
    on(successGetQuestions, (state, { data }) => ({ ...state, loading: false, success: true, failed: false, error: null, data })),
    on(errorGetQuestions, (state, { payload }) => ({ ...state, loading: false, success: false, failed: true, error: payload, data: [] })),
    on(clearGetQuestions, state => ({ ...state, ...QuestionsInit }))
);

export function QuestionsReducer(state: any, action: any) {
    return _questionsReducer(state, action);
}